/*
 * @Description: In User Settings Edit
 * @Author: laikt
 * @LastEditors: laikt
 * @Date: 2019-03-20 10:26:10
 * @LastEditTime: 2019-04-04 11:13:50
 */
//获取 当前菜单下的面包屑导航
export function getBreadcrum(breadcrumList, active) {
    const breadcrumMenu = Object.assign([], breadcrumList);
    // console.log(breadcrumMenu);
    let list = [];
    var getBreadcrumItem = function getBreadcrumItem(menuList, active) {
        console.log(active);
        for (let index = 0; index < menuList.length; index++) {
            const element = menuList[index];
            if (element.id === active) {
                // let el = {
                //     name: element.name,
                //     path: element.demoFlag,
                //     parentId: element.parentId
                // };
                list.push(element);
                if (element.deep !== 1) {
                    getBreadcrumItem(breadcrumMenu, element.parentId);
                }
            } else {
                if (Array.isArray(element.children)) {
                    getBreadcrumItem(element.children, active);
                }
            }
        }
        // return list;
    };
    getBreadcrumItem(breadcrumMenu, active);
    list.push(breadcrumList[0]);
    console.log(list);
    return list;
}
//获取 当前菜单下的子菜单
export const getChildMenu = (breadcrumList, active) => {
    const breadcrumMenu = Object.assign([], breadcrumList);
    // console.log(breadcrumMenu);
    let list = [];
    var getChildMenuItem = (menuList, active) => {
        for (let index = 0; index < menuList.length; index++) {
            const element = menuList[index];
            if (element.id === active) {
                if (Array.isArray(element.children)) {
                    list = element.children;
                }
            }
            if (Array.isArray(element.children)) {
                getChildMenuItem(element.children, active);
            }
        }
    };
    getChildMenuItem(breadcrumMenu, active);
    return list;
};

//获取 当前菜单下的菜单
export const getMenu = (breadcrumList, active) => {
    const breadcrumMenu = Object.assign([], breadcrumList);
    // console.log(breadcrumMenu);
    let list = [];
    var getChildMenuItem = (menuList, active) => {
        for (let index = 0; index < menuList.length; index++) {
            const element = menuList[index];
            if (element.id === active) {
                list = element;
            }
            if (Array.isArray(element.children)) {
                getChildMenuItem(element.children, active);
            }
        }
    };
    getChildMenuItem(breadcrumMenu, active);
    return list;
};
//获取 右上角会员中心菜单
export const getRightTop = (breadcrumList, active) => {
    const breadcrumMenu = Object.assign([], breadcrumList);
    // console.log(breadcrumMenu);
    let list = [];
    var getChildMenuItem = (menuList, active) => {
        for (let index = 0; index < menuList.length; index++) {
            const element = menuList[index];
            if (element.type === active) {
                list.push(element);
            }
            if (Array.isArray(element.children)) {
                getChildMenuItem(element.children, "1");
            }
        }
    };
    getChildMenuItem(breadcrumMenu, "1");
    console.log(list);

    return list;
};
